<div class="direct-address" [formGroup]="form">
  <div class="direct-address__header">
    <h3 class="direct-address__title">Shipping Address (Device Delivery)</h3>
  </div>

  <div class="grid grid-cols-6 gap-2">
    <mat-form-field appearance="outline" class="col-span-3">
      <mat-label>Address Line 1</mat-label>
      <input
        matInput
        required
        formControlName="line1"
        [maxlength]="lineMax"
        [matAutocomplete]="streetSuggestions.panel"
        [matAutocompleteDisabled]="!streetSuggestions.active"
        (focus)="streetSuggestions.warmUp()"
        (input)="streetSuggestions.search($any($event.target).value)"
      />
      <mat-error *ngIf="hasServerProblem('line1')">{{ serverProblem('line1') }}</mat-error>
      <mat-error *ngIf="!hasServerProblem('line1') && form.controls.line1.errors?.['required']">Required field</mat-error>
    </mat-form-field>

    <app-address-suggestions #streetSuggestions [usOnly]="true" (picked)="applySuggestion($event)"></app-address-suggestions>

    <mat-form-field appearance="outline" class="col-span-3">
      <mat-label>Address Line 2</mat-label>
      <input matInput formControlName="line2" [maxlength]="lineMax" />
      <mat-error *ngIf="hasServerProblem('line2')">{{ serverProblem('line2') }}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>City</mat-label>
      <input matInput required formControlName="city" />
      <mat-error *ngIf="hasServerProblem('city')">{{ serverProblem('city') }}</mat-error>
      <mat-error *ngIf="!hasServerProblem('city') && form.controls.city.errors?.['required']">Required field</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-span-1">
      <mat-label>State</mat-label>
      <mat-select required formControlName="state">
        <mat-option *ngFor="let state of states" [value]="state.code">{{ state.name }}</mat-option>
      </mat-select>
      <mat-error *ngIf="hasServerProblem('state')">{{ serverProblem('state') }}</mat-error>
      <mat-error *ngIf="!hasServerProblem('state') && form.controls.state.errors?.['required']">Required field</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-span-1">
      <mat-label>Postal Code</mat-label>
      <input matInput required formControlName="postalCode" />
      <mat-error *ngIf="hasServerProblem('postalCode')">{{ serverProblem('postalCode') }}</mat-error>
      <mat-error *ngIf="!hasServerProblem('postalCode') && form.controls.postalCode.errors?.['required']">Required field</mat-error>
      <mat-error *ngIf="!hasServerProblem('postalCode') && form.controls.postalCode.errors?.['pattern']">5-digit ZIP code</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-span-2">
      <mat-label>Country</mat-label>
      <input matInput value="United States" disabled />
    </mat-form-field>
  </div>

  <!-- Verified on its own when an address is picked from the suggestions; a typed
       one is verified with the small button. Changing any field takes it back. -->
  <div class="direct-address__verify">
    <span *ngIf="validated" class="direct-address__chip direct-address__chip--ok" role="status">
      <mat-icon>check_circle</mat-icon>Verified
    </span>
    <button
      *ngIf="!validated"
      mat-stroked-button
      type="button"
      class="direct-address__verify-button"
      [disabled]="checking"
      (click)="validate()"
    >
      <mat-spinner *ngIf="checking" diameter="12" strokeWidth="2"></mat-spinner>
      <span>{{ checking ? 'Verifying…' : 'Verify' }}</span>
    </button>
    <span *ngIf="correctionNote" class="direct-address__note">{{ correctionNote }}</span>
    <span *ngIf="refusal" class="direct-address__note direct-address__note--bad" role="alert">{{ refusal }}</span>
    <span *ngIf="needsValidation && !validated && !refusal" class="direct-address__note direct-address__note--bad" role="alert">
      Verify the address before continuing.
    </span>
  </div>
</div>
